import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../core/services/config/config.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { NotificationPreference } from '../../models/notification-preference';
import { NotificationPreferenceRequest } from '../../models/notification-preference-request';

@Injectable({
  providedIn: 'root',
})
export class NotificationPreferencesService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;

  // User-keyed: the subject is the calling portal user, resolved from the token. No patient id is
  // sent, and the PatientAccess policy does not apply to these routes.
  notificationPreferencesEndpoint = `${this.config.patientApiUrl}/v1/PatientPortal/UserNotificationPreferences`;

  getNotificationPreferences(): Observable<NotificationPreference> {
    return this.utilityService.getRequest<NotificationPreference>(this.notificationPreferencesEndpoint);
  }

  // skipGlobalError, or the API's no-clear rejection never reaches this feature: a 400 is neither
  // 401 nor 403, so the error interceptor would dispatch setGlobalError, which closes any open
  // dialog and navigates to /error — the two outcomes the save surfaces must not produce. The form
  // renders the failure itself as an in-context role="alert".
  putNotificationPreferences(
    notificationPreferenceRequest: NotificationPreferenceRequest
  ): Observable<NotificationPreference> {
    return this.utilityService.putRequest<NotificationPreference>(
      this.notificationPreferencesEndpoint,
      notificationPreferenceRequest,
      { skipGlobalError: true }
    );
  }
}
